<div class="message-date ng-star-inserted">{{ formattedDate }}</div>
